// Ready-made agendas for the four Scrum events. Sprint Planning, Review and
// Retrospective scale with the sprint length (per the Scrum Guide's
// time-boxing guidance); Daily Scrum stays 15 minutes regardless.
export const scrumExamples = [
  {
    event: "Daily Scrum",
    description:
      "A quick daily sync for the Developers - always 15 minutes, no matter how long the sprint is.",
    variants: [
      {
        label: "15 min",
        agenda: [{ topic: "Daily Scrum", time: "00:15:00" }],
      },
    ],
  },
  {
    event: "Sprint Planning",
    description:
      "Agree the Sprint Goal, select Product Backlog items, and plan the work.",
    variants: [
      {
        label: "1-week sprint (2h)",
        agenda: [
          { topic: "Agree the Sprint Goal", time: "00:30:00" },
          { topic: "Select Backlog Items", time: "00:40:00" },
          { topic: "Plan the Work", time: "00:50:00" },
        ],
      },
      {
        label: "2-week sprint (4h)",
        agenda: [
          { topic: "Agree the Sprint Goal", time: "00:45:00" },
          { topic: "Select Backlog Items", time: "01:15:00" },
          { topic: "Plan the Work", time: "02:00:00" },
        ],
      },
      {
        label: "4-week sprint (8h)",
        agenda: [
          { topic: "Agree the Sprint Goal", time: "01:30:00" },
          { topic: "Select Backlog Items", time: "02:30:00" },
          { topic: "Plan the Work", time: "04:00:00" },
        ],
      },
    ],
  },
  {
    event: "Sprint Review",
    description:
      "Inspect the increment with stakeholders and adapt the Product Backlog.",
    variants: [
      {
        label: "1-week sprint (1h)",
        agenda: [
          { topic: "Recap the Sprint Goal", time: "00:10:00" },
          { topic: "Demo the Increment", time: "00:30:00" },
          { topic: "Stakeholder Feedback", time: "00:15:00" },
          { topic: "Update the Product Backlog", time: "00:05:00" },
        ],
      },
      {
        label: "2-week sprint (2h)",
        agenda: [
          { topic: "Recap the Sprint Goal", time: "00:15:00" },
          { topic: "Demo the Increment", time: "01:00:00" },
          { topic: "Stakeholder Feedback", time: "00:30:00" },
          { topic: "Update the Product Backlog", time: "00:15:00" },
        ],
      },
      {
        label: "4-week sprint (4h)",
        agenda: [
          { topic: "Recap the Sprint Goal", time: "00:20:00" },
          { topic: "Demo the Increment", time: "02:00:00" },
          { topic: "Stakeholder Feedback", time: "01:10:00" },
          { topic: "Update the Product Backlog", time: "00:30:00" },
        ],
      },
    ],
  },
  {
    event: "Sprint Retrospective",
    description:
      "Inspect how the last sprint went - people, process and tools - and plan improvements.",
    variants: [
      {
        label: "1-week sprint (45 min)",
        agenda: [
          { topic: "Set the Stage", time: "00:05:00" },
          { topic: "Gather Data", time: "00:10:00" },
          { topic: "Generate Insights", time: "00:15:00" },
          { topic: "Decide What to Do", time: "00:10:00" },
          { topic: "Close the Retro", time: "00:05:00" },
        ],
      },
      {
        label: "2-week sprint (1.5h)",
        agenda: [
          { topic: "Set the Stage", time: "00:10:00" },
          { topic: "Gather Data", time: "00:20:00" },
          { topic: "Generate Insights", time: "00:25:00" },
          { topic: "Decide What to Do", time: "00:25:00" },
          { topic: "Close the Retro", time: "00:10:00" },
        ],
      },
      {
        label: "4-week sprint (3h)",
        agenda: [
          { topic: "Set the Stage", time: "00:15:00" },
          { topic: "Gather Data", time: "00:40:00" },
          { topic: "Generate Insights", time: "00:50:00" },
          { topic: "Decide What to Do", time: "00:55:00" },
          { topic: "Close the Retro", time: "00:20:00" },
        ],
      },
    ],
  },
];

// Pomodoro schedules for a focused work block: 25-minute Focus sessions
// separated by 5-minute Short Breaks, a Long Break after every four
// Pomodoros, and a Lunch Break worked in for the longer, workday-sized
// sessions.
export const pomodoroExamples = [
  {
    event: "Pomodoro Timer",
    description:
      "Work in focused 25-minute Pomodoros with Short Breaks in between, a Long Break after every 4 Pomodoros, and a Lunch Break on longer days. Choose how long you want to work.",
    variants: [
      {
        label: "1 hour",
        agenda: [
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
        ],
      },
      {
        label: "2 hours",
        agenda: [
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
        ],
      },
      {
        label: "4 hours",
        agenda: [
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Long Break", time: "00:10:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
        ],
      },
      {
        label: "6 hours",
        agenda: [
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Long Break", time: "00:15:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Lunch Break", time: "01:00:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
        ],
      },
      {
        label: "8 hours",
        agenda: [
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Long Break", time: "00:15:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Lunch Break", time: "00:45:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Long Break", time: "00:15:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Short Break", time: "00:05:00" },
          { topic: "Focus", time: "00:25:00" },
          { topic: "Wrap Up", time: "00:05:00" },
        ],
      },
    ],
  },
];

// Agendas for meetings, workshops, retrospectives and talks. Cards carry
// a type (shown as a coloured stripe) and, where it helps the facilitator,
// a short note. Every variant's cards add up to the duration in its label
// (checked in examples.test.js).
export const meetingExamples = [
  {
    event: "Team Meeting",
    description:
      "A regular team sync: quick check-in, updates, the topics that need the group, and clear action items.",
    variants: [
      {
        label: "30 min",
        agenda: [
          { topic: "Check-in", time: "00:03:00", type: "discussion" },
          {
            topic: "Updates",
            time: "00:10:00",
            type: "input",
            note: "One minute per person, details go to the topics",
          },
          { topic: "Topics", time: "00:12:00", type: "discussion" },
          {
            topic: "Action Items",
            time: "00:05:00",
            note: "Who does what by when",
          },
        ],
      },
      {
        label: "1h",
        agenda: [
          { topic: "Check-in", time: "00:05:00", type: "discussion" },
          {
            topic: "Updates",
            time: "00:15:00",
            type: "input",
            note: "One minute per person, details go to the topics",
          },
          { topic: "Topic 1", time: "00:15:00", type: "discussion" },
          { topic: "Topic 2", time: "00:15:00", type: "discussion" },
          {
            topic: "Action Items",
            time: "00:10:00",
            note: "Who does what by when",
          },
        ],
      },
    ],
  },
  {
    event: "1:1",
    description:
      "A one-on-one where the other person's topics come first, followed by feedback in both directions.",
    variants: [
      {
        label: "30 min",
        agenda: [
          { topic: "Check-in", time: "00:05:00", type: "discussion" },
          {
            topic: "Their Topics",
            time: "00:15:00",
            type: "discussion",
            note: "Their agenda first, yours second",
          },
          {
            topic: "Feedback",
            time: "00:05:00",
            type: "discussion",
            note: "Both directions",
          },
          { topic: "Next Steps", time: "00:05:00" },
        ],
      },
    ],
  },
  {
    event: "Decision Meeting",
    description:
      "Get from options to a decision: shared context, questions, pros and cons, then decide and assign.",
    variants: [
      {
        label: "45 min",
        agenda: [
          { topic: "Context & Options", time: "00:10:00", type: "input" },
          {
            topic: "Clarifying Questions",
            time: "00:10:00",
            type: "discussion",
            note: "Questions only, no opinions yet",
          },
          { topic: "Pros & Cons", time: "00:15:00", type: "discussion" },
          {
            topic: "Decide",
            time: "00:05:00",
            note: "Agree on the rule first: consent, majority or the owner decides",
          },
          { topic: "Next Steps", time: "00:05:00" },
        ],
      },
    ],
  },
  {
    event: "Lean Coffee",
    description:
      "An agenda-less meeting: collect topics, vote, and discuss them in order with short timeboxes.",
    variants: [
      {
        label: "45 min",
        agenda: [
          {
            topic: "Collect Topics",
            time: "00:05:00",
            type: "work",
            note: "One topic per sticky note",
          },
          {
            topic: "Dot Vote",
            time: "00:03:00",
            type: "work",
            note: "Two or three dots each",
          },
          {
            topic: "Topic 1",
            time: "00:08:00",
            type: "discussion",
            note: "Thumbs vote at the end: keep going or next topic",
          },
          { topic: "Topic 2", time: "00:08:00", type: "discussion" },
          { topic: "Topic 3", time: "00:08:00", type: "discussion" },
          { topic: "Topic 4", time: "00:08:00", type: "discussion" },
          { topic: "Wrap Up", time: "00:05:00" },
        ],
      },
      {
        label: "1h",
        agenda: [
          {
            topic: "Collect Topics",
            time: "00:07:00",
            type: "work",
            note: "One topic per sticky note",
          },
          {
            topic: "Dot Vote",
            time: "00:03:00",
            type: "work",
            note: "Two or three dots each",
          },
          {
            topic: "Topic 1",
            time: "00:08:00",
            type: "discussion",
            note: "Thumbs vote at the end: keep going or next topic",
          },
          { topic: "Topic 2", time: "00:08:00", type: "discussion" },
          { topic: "Topic 3", time: "00:08:00", type: "discussion" },
          { topic: "Topic 4", time: "00:08:00", type: "discussion" },
          { topic: "Topic 5", time: "00:08:00", type: "discussion" },
          { topic: "Wrap Up", time: "00:10:00" },
        ],
      },
    ],
  },
  {
    event: "All-Hands",
    description:
      "A company or department meeting with updates, spotlights, recognition and open Q&A.",
    variants: [
      {
        label: "1h",
        agenda: [
          { topic: "Welcome", time: "00:05:00", type: "input" },
          { topic: "Updates", time: "00:15:00", type: "input" },
          { topic: "Team Spotlights", time: "00:15:00", type: "input" },
          { topic: "Recognition", time: "00:05:00" },
          {
            topic: "Q&A",
            time: "00:15:00",
            type: "discussion",
            note: "Collect questions in advance as well",
          },
          { topic: "Close", time: "00:05:00" },
        ],
      },
    ],
  },
];

export const workshopExamples = [
  {
    event: "Workshop",
    description:
      "A classic workshop arc: goals and check-in, input, group work, sharing results, prioritising and next steps.",
    variants: [
      {
        label: "Half day (3h)",
        agenda: [
          { topic: "Welcome & Goals", time: "00:15:00", type: "input" },
          { topic: "Check-in", time: "00:15:00", type: "discussion" },
          { topic: "Input", time: "00:20:00", type: "input" },
          {
            topic: "Group Work",
            time: "00:40:00",
            type: "work",
            note: "Groups of 3-5, one question each",
          },
          { topic: "Break", time: "00:15:00", type: "break" },
          {
            topic: "Share Results",
            time: "00:25:00",
            type: "discussion",
            note: "Max. 5 minutes per group",
          },
          { topic: "Prioritise", time: "00:20:00", type: "work" },
          {
            topic: "Next Steps",
            time: "00:15:00",
            note: "Who does what by when",
          },
          { topic: "Check-out", time: "00:15:00", type: "discussion" },
        ],
      },
      {
        label: "Full day (7h)",
        agenda: [
          { topic: "Welcome & Goals", time: "00:20:00", type: "input" },
          { topic: "Check-in", time: "00:20:00", type: "discussion" },
          { topic: "Input I", time: "00:30:00", type: "input" },
          {
            topic: "Group Work I",
            time: "01:00:00",
            type: "work",
            note: "Groups of 3-5, one question each",
          },
          { topic: "Break", time: "00:15:00", type: "break" },
          { topic: "Share Results", time: "00:30:00", type: "discussion" },
          { topic: "Lunch Break", time: "01:00:00", type: "break" },
          { topic: "Energizer", time: "00:10:00", type: "work" },
          { topic: "Input II", time: "00:20:00", type: "input" },
          { topic: "Group Work II", time: "01:00:00", type: "work" },
          { topic: "Break", time: "00:15:00", type: "break" },
          { topic: "Share & Prioritise", time: "00:40:00", type: "discussion" },
          {
            topic: "Next Steps",
            time: "00:20:00",
            note: "Who does what by when",
          },
          { topic: "Check-out", time: "00:20:00", type: "discussion" },
        ],
      },
    ],
  },
  {
    event: "Project Kickoff",
    description:
      "Start a project with a shared picture of the why, the goals, the scope, the roles and the road ahead.",
    variants: [
      {
        label: "1h",
        agenda: [
          { topic: "Welcome & Intros", time: "00:10:00", type: "input" },
          { topic: "Goals & Scope", time: "00:15:00", type: "input" },
          {
            topic: "Roles & Responsibilities",
            time: "00:10:00",
            type: "discussion",
          },
          { topic: "Timeline & Milestones", time: "00:10:00", type: "input" },
          {
            topic: "Risks & Open Questions",
            time: "00:10:00",
            type: "discussion",
          },
          { topic: "Next Steps", time: "00:05:00" },
        ],
      },
      {
        label: "Half day (3h 30m)",
        agenda: [
          { topic: "Welcome & Check-in", time: "00:15:00", type: "input" },
          { topic: "Why This Project", time: "00:20:00", type: "input" },
          { topic: "Goals & Success Criteria", time: "00:30:00", type: "work" },
          { topic: "Break", time: "00:15:00", type: "break" },
          {
            topic: "Scope: In & Out",
            time: "00:30:00",
            type: "work",
            note: "What we explicitly won't do matters as much",
          },
          {
            topic: "Roles & Ways of Working",
            time: "00:30:00",
            type: "discussion",
          },
          { topic: "Break", time: "00:10:00", type: "break" },
          { topic: "Timeline & Milestones", time: "00:25:00", type: "input" },
          { topic: "Risks", time: "00:20:00", type: "discussion" },
          { topic: "Next Steps & Check-out", time: "00:15:00" },
        ],
      },
    ],
  },
  {
    event: "Brainstorming",
    description:
      "Generate many ideas first, then cluster and pick: silent ideation before discussion gets every voice in.",
    variants: [
      {
        label: "45 min",
        agenda: [
          {
            topic: "Frame the Question",
            time: "00:05:00",
            type: "input",
            note: 'Phrase it as "How might we ...?"',
          },
          {
            topic: "Silent Ideation",
            time: "00:10:00",
            type: "work",
            note: "Alone, one idea per sticky note",
          },
          { topic: "Share Ideas", time: "00:10:00", type: "discussion" },
          { topic: "Cluster", time: "00:08:00", type: "work" },
          { topic: "Dot Vote", time: "00:07:00", type: "work" },
          { topic: "Next Steps", time: "00:05:00" },
        ],
      },
      {
        label: "1h 30m",
        agenda: [
          {
            topic: "Frame the Challenge",
            time: "00:10:00",
            type: "input",
            note: 'Phrase it as "How might we ...?"',
          },
          { topic: "Warm-up", time: "00:05:00", type: "work" },
          {
            topic: "Silent Ideation",
            time: "00:15:00",
            type: "work",
            note: "Alone, one idea per sticky note",
          },
          { topic: "Share Ideas", time: "00:15:00", type: "discussion" },
          {
            topic: "Build on Ideas",
            time: "00:15:00",
            type: "work",
            note: '"Yes, and ..." - combine and extend',
          },
          { topic: "Cluster", time: "00:10:00", type: "work" },
          { topic: "Dot Vote", time: "00:10:00", type: "work" },
          { topic: "Next Steps", time: "00:10:00" },
        ],
      },
    ],
  },
  {
    event: "Design Sprint",
    description:
      "The five-day Design Sprint, one agenda per day: map the problem, sketch solutions, decide, prototype and test with users.",
    variants: [
      {
        label: "Day 1: Map (6h)",
        agenda: [
          { topic: "Long-term Goal", time: "00:30:00", type: "discussion" },
          { topic: "Sprint Questions", time: "00:30:00", type: "discussion" },
          { topic: "Make a Map", time: "01:00:00", type: "work" },
          { topic: "Break", time: "00:15:00", type: "break" },
          {
            topic: "Ask the Experts",
            time: "01:30:00",
            type: "input",
            note: 'Everyone writes "How might we" notes',
          },
          { topic: "Lunch Break", time: "01:00:00", type: "break" },
          { topic: "Organise HMW Notes", time: "00:45:00", type: "work" },
          { topic: "Pick a Target", time: "00:30:00", type: "discussion" },
        ],
      },
      {
        label: "Day 2: Sketch (6h)",
        agenda: [
          { topic: "Lightning Demos", time: "01:30:00", type: "input" },
          { topic: "Break", time: "00:15:00", type: "break" },
          { topic: "Divide or Swarm", time: "00:15:00", type: "discussion" },
          { topic: "Lunch Break", time: "01:00:00", type: "break" },
          { topic: "Notes", time: "00:20:00", type: "work" },
          { topic: "Ideas", time: "00:20:00", type: "work" },
          {
            topic: "Crazy 8s",
            time: "00:10:00",
            type: "work",
            note: "Eight variations in eight minutes",
          },
          { topic: "Solution Sketch", time: "01:30:00", type: "work" },
          { topic: "Recruit Testers", time: "00:40:00" },
        ],
      },
      {
        label: "Day 3: Decide (6h)",
        agenda: [
          {
            topic: "Art Museum",
            time: "00:20:00",
            type: "work",
            note: "Hang up all sketches",
          },
          { topic: "Heat Map", time: "00:15:00", type: "work" },
          { topic: "Speed Critique", time: "01:00:00", type: "discussion" },
          { topic: "Straw Poll", time: "00:10:00", type: "work" },
          {
            topic: "Supervote",
            time: "00:10:00",
            type: "work",
            note: "The Decider decides",
          },
          { topic: "Break", time: "00:15:00", type: "break" },
          { topic: "Lunch Break", time: "01:00:00", type: "break" },
          { topic: "Storyboard", time: "02:50:00", type: "work" },
        ],
      },
      {
        label: "Day 4: Prototype (6h)",
        agenda: [
          { topic: "Assign Roles", time: "00:30:00", type: "discussion" },
          { topic: "Build the Prototype", time: "02:30:00", type: "work" },
          { topic: "Lunch Break", time: "01:00:00", type: "break" },
          { topic: "Finish the Prototype", time: "01:30:00", type: "work" },
          { topic: "Trial Run", time: "00:30:00", type: "work" },
        ],
      },
      {
        label: "Day 5: Test (6h 15m)",
        agenda: [
          { topic: "Interview 1", time: "00:45:00", type: "work" },
          { topic: "Notes", time: "00:15:00", type: "discussion" },
          { topic: "Interview 2", time: "00:45:00", type: "work" },
          { topic: "Notes", time: "00:15:00", type: "discussion" },
          { topic: "Lunch Break", time: "01:00:00", type: "break" },
          { topic: "Interview 3", time: "00:45:00", type: "work" },
          { topic: "Notes", time: "00:15:00", type: "discussion" },
          { topic: "Interview 4", time: "00:45:00", type: "work" },
          { topic: "Notes", time: "00:15:00", type: "discussion" },
          { topic: "Interview 5", time: "00:45:00", type: "work" },
          {
            topic: "Debrief & Next Steps",
            time: "00:30:00",
            type: "discussion",
          },
        ],
      },
    ],
  },
];

export const retroExamples = [
  {
    event: "Start, Stop, Continue",
    description:
      "A simple, quick retro format: what to start doing, what to stop, and what to keep.",
    variants: [
      {
        label: "45 min",
        agenda: [
          { topic: "Set the Stage", time: "00:05:00", type: "discussion" },
          {
            topic: "Write Cards",
            time: "00:10:00",
            type: "work",
            note: "Start / Stop / Continue, one idea per card",
          },
          { topic: "Share & Cluster", time: "00:15:00", type: "discussion" },
          {
            topic: "Pick Actions",
            time: "00:10:00",
            type: "work",
            note: "Two or three, each with an owner",
          },
          { topic: "Close", time: "00:05:00" },
        ],
      },
    ],
  },
  {
    event: "Mad, Sad, Glad",
    description:
      "A retro that starts from feelings: what made the team mad, sad or glad, and what to do about it.",
    variants: [
      {
        label: "1h",
        agenda: [
          { topic: "Set the Stage", time: "00:05:00", type: "discussion" },
          {
            topic: "Write Cards",
            time: "00:10:00",
            type: "work",
            note: "Mad / Sad / Glad",
          },
          { topic: "Share & Cluster", time: "00:20:00", type: "discussion" },
          {
            topic: "Dig into Top Topics",
            time: "00:15:00",
            type: "discussion",
          },
          { topic: "Pick Actions", time: "00:07:00", type: "work" },
          { topic: "Close", time: "00:03:00" },
        ],
      },
    ],
  },
  {
    event: "4Ls",
    description:
      "Liked, Learned, Lacked, Longed for - a balanced look back that also surfaces learning.",
    variants: [
      {
        label: "1h",
        agenda: [
          { topic: "Set the Stage", time: "00:05:00", type: "discussion" },
          {
            topic: "Write Cards",
            time: "00:10:00",
            type: "work",
            note: "Liked / Learned / Lacked / Longed for",
          },
          { topic: "Share", time: "00:20:00", type: "discussion" },
          { topic: "Discuss", time: "00:15:00", type: "discussion" },
          { topic: "Pick Actions", time: "00:07:00", type: "work" },
          { topic: "Close", time: "00:03:00" },
        ],
      },
    ],
  },
  {
    event: "Sailboat",
    description:
      "A visual retro: wind that pushes the team forward, anchors that hold it back, rocks ahead and the island it's heading for.",
    variants: [
      {
        label: "1h 15m",
        agenda: [
          { topic: "Set the Stage", time: "00:05:00", type: "discussion" },
          { topic: "Draw the Boat", time: "00:05:00", type: "input" },
          {
            topic: "Write Cards",
            time: "00:15:00",
            type: "work",
            note: "Wind / Anchors / Rocks / Island",
          },
          { topic: "Share", time: "00:20:00", type: "discussion" },
          { topic: "Discuss", time: "00:15:00", type: "discussion" },
          { topic: "Pick Actions", time: "00:10:00", type: "work" },
          { topic: "Close", time: "00:05:00" },
        ],
      },
    ],
  },
];

export const talkExamples = [
  {
    event: "Talk with Q&A",
    description: "A presentation followed by questions from the audience.",
    variants: [
      {
        label: "30 min",
        agenda: [
          { topic: "Welcome", time: "00:02:00", type: "input" },
          { topic: "Talk", time: "00:18:00", type: "input" },
          { topic: "Q&A", time: "00:10:00", type: "discussion" },
        ],
      },
      {
        label: "1h",
        agenda: [
          { topic: "Welcome", time: "00:05:00", type: "input" },
          { topic: "Talk", time: "00:35:00", type: "input" },
          { topic: "Q&A", time: "00:15:00", type: "discussion" },
          { topic: "Wrap Up", time: "00:05:00" },
        ],
      },
    ],
  },
  {
    event: "Study Session",
    description:
      "Learn in focused blocks with breaks, then practise by recalling instead of re-reading.",
    variants: [
      {
        label: "1h 30m",
        agenda: [
          {
            topic: "Plan the Session",
            time: "00:05:00",
            note: "What should you be able to do afterwards?",
          },
          { topic: "Learn", time: "00:25:00", type: "work" },
          { topic: "Short Break", time: "00:05:00", type: "break" },
          { topic: "Learn", time: "00:25:00", type: "work" },
          { topic: "Short Break", time: "00:05:00", type: "break" },
          {
            topic: "Practise & Recall",
            time: "00:20:00",
            type: "work",
            note: "Close the book, write down what you remember",
          },
          { topic: "Review", time: "00:05:00" },
        ],
      },
      {
        label: "3h",
        agenda: [
          {
            topic: "Plan the Session",
            time: "00:10:00",
            note: "What should you be able to do afterwards?",
          },
          { topic: "Learn", time: "00:45:00", type: "work" },
          { topic: "Short Break", time: "00:10:00", type: "break" },
          { topic: "Learn", time: "00:45:00", type: "work" },
          { topic: "Long Break", time: "00:15:00", type: "break" },
          {
            topic: "Practise & Recall",
            time: "00:40:00",
            type: "work",
            note: "Close the book, write down what you remember",
          },
          { topic: "Review", time: "00:15:00" },
        ],
      },
    ],
  },
];
